import { Grid, TextField, Typography, FormControl } from "@mui/material";
import { Container } from "@mui/system";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useAuthContext } from "../hooks/useAuthContext";
import React from "react";
import "../assets/css/login.css";

import companyLogo from "../assets/images/Logo/logo.png";
import loginBackgroundImage from "../assets/images/login/login.jpg";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import {
  config,
  adminLoginAPI,
  forgotPasswordAPI,
  resetPasswordAPI,
  verifyOTPAPI,
  resetPasswordEmailAPI,
  baseURL,
  menuPermissionsAPI,
} from "../config";
import TwoFactorModal from "../components/TwoFactorModal";
import { AlertMessage } from "../components/AlertMessage";
import moment from "moment";

function Login() {
  const navigate = useNavigate();
  const childRef = useRef();
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      if (user.role == "user") {
        navigate("/user/ticket/list");
      } else if (user.role === "agent" || user.role === "Admin") {
        navigate("/agent/dashboard");
      }
    }

    return () => true;
  }, []);

  const [data, setData] = useState({});

  const validationSchema = Yup.object().shape({
    txtPassword: Yup.string().required("Password is required"),
    txtEmail: Yup.string()
      .required("Email is required")
      .email("Please enter valid email format"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, reset, formState } = useForm(formOptions);

  const { errors } = formState;

  const [alertType, setAlertType] = useState("success");
  const [errMessage, setErrMessage] = useState("");
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [intOTP, setOTP] = useState("");

  const [txtResetPassword, setResetPassword] = useState("");
  const [txtResetConfirmPassword, setResetConfirmPassword] = useState("");

  const [open, setOpen] = useState(false);
  const [isLoadingSubmit, setLodingSubmit] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isVerifiedOTP, setIsVerifiedOTP] = useState(false);

  const [isSendOTP, setIsSendOTP] = useState(false);
  // const { login, isLoding, error } = useLogin();
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { dispatch } = useAuthContext();

  const [show2FAModal, setShow2FAModal] = useState(false);
  const [twoFactorData, setTwoFactorData] = useState({
    requireEnrollment: false,
    require2FA: false,
    qrCode: "",
    secret: "",
    tempToken: "",
  });
  const [loading2FA, setLoading2FA] = useState(false);

  // const navigate = useNavigate();
  function onSubmit(data) {
    setLodingSubmit(true);
    setError(null);
    var reqData = JSON.stringify({
      txtUsername: data.txtEmail,
      txtPassword: data.txtPassword,
      txtDate: moment().format("YYYY-MM-DD"),
      intType: 1,
    });

    config.method = "POST";
    config.url = adminLoginAPI;
    config.data = reqData;

    axios(config)
      .then(function (response) {
        if (response.data.require2FA || response.data.requireEnrollment) {
          setTwoFactorData({
            requireEnrollment: !!response.data.requireEnrollment,
            require2FA: !!response.data.require2FA,
            qrCode: response.data.qrCode || "",
            secret: response.data.secret || "",
            tempToken: response.data.tempToken || "",
          });
          setShow2FAModal(true);
          setLodingSubmit(false);
          return;
        }

        if (response.data.result != 0) {
          localStorage.setItem("user", JSON.stringify(response.data.result[0]));

          //Remove existing local storage
          localStorage.removeItem("isProjectLoggedIn");
          localStorage.removeItem("projectID");
          localStorage.removeItem("projectAutoID");
          localStorage.removeItem("projectName");
          localStorage.removeItem("projectCheckInTime");
          localStorage.removeItem("userAttandenceLogin");

          if (
            response.data.result[1] &&
            response.data.result[1].working_hours == ""
          ) {
            if (
              !response.data.result[1].end_time ||
              (response.data.result[1].end_time = "0000-00-00 00:00:00")
            ) {
              localStorage.setItem("isProjectLoggedIn", true);
              localStorage.setItem(
                "projectID",
                response.data.result[1].project_id
                  ? response.data.result[1].project_id
                  : 0
              );
              localStorage.setItem(
                "projectAutoID",
                response.data.result[1].id ? response.data.result[1].id : 0
              );
              localStorage.setItem(
                "projectName",
                response.data.result[1].project_name
                  ? response.data.result[1].project_name
                  : ""
              );
              localStorage.setItem(
                "projectCheckInTime",
                response.data.result[1].start_time
                  ? response.data.result[1].start_time
                  : ""
              );
              localStorage.setItem("userAttandenceLogin", "true");
            }
          }

          dispatch({ type: "LOGIN", payload: "jsonData" });

          let user = response.data.result[0];
          if (user.role_id === 36) {
            window.location.href = "/unauthorized";
          } else if (user.role_id === 34) {
            window.location.href = "/dashboard";
          } else {
            const positionId = user.position || user.txtPosition;
            if (positionId) {
              axios.get(`${menuPermissionsAPI}/by-position/${positionId}`, {
                headers: {
                  ...config.headers,
                  Authorization: "Bearer " + user.token
                }
              })
                .then((permRes) => {
                  const perms = permRes.data.result || [];
                  window.location.href = getFirstAllowedPage(perms);
                })
                .catch(() => {
                  window.location.href = "/unauthorized";
                });
            } else {
              window.location.href = "/unauthorized";
            }
          }
        } else {
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/adminlogin";
        }
        console.log(error);
        setErrMessage("Invalid Username or Password");
      });
  }

  // Helper to determine the first allowed page URL based on permissions list
  const getFirstAllowedPage = (perms) => {
    // Define exact submenu key to URL mapping in priority order
    const menuMap = [
      { key: "dashboard", url: "/dashboard" },
      { key: "po_wo_dashboard", url: "/purchase-work-order-dashboard" },
      // HR Management
      { key: "employees", url: "/employee/list" },
      { key: "employee_attendance", url: "/employee-attendance" },
      { key: "payroll_process", url: "/payroll-process" },
      { key: "payslip_report", url: "/payslip-report" },
      { key: "yearly_bonus", url: "/yearly-bonus" },
      { key: "leave_approval", url: "/Leave/approval" },
      { key: "advance_payment_report", url: "/advance-payment/list" },
      // Purchase Order
      { key: "purchase_order_create", url: "/purchase-order/create" },
      { key: "purchase_order_list", url: "/purchase-order/list" },
      { key: "po_add_terms", url: "/termsandconditions/add" },
      { key: "po_list_terms", url: "/termsandconditions/list" },
      // Invoice
      { key: "invoice_create", url: "/invoice/create" },
      { key: "invoice_list", url: "/invoice/list" },
      { key: "invoice_add_terms", url: "/invoiceTermsAndConditions/add" },
      { key: "invoice_list_terms", url: "/invoiceTermsAndConditions/list" },
      // Masters
      { key: "clients", url: "/client/list" },
      { key: "projects", url: "/project/list" },
      { key: "store", url: "/store/list" },
      { key: "vendor", url: "/vendor/list" },
      { key: "payment_requests", url: "/payment-request/list" },
      // Configurations
      { key: "configuration", url: "/config/configuration" },
      { key: "departments", url: "/config/departments-master" },
      { key: "positions", url: "/config/positions-master" },
      { key: "allowances", url: "/manage-allowances" },
      { key: "holidays", url: "/add-holiday" },
      { key: "companies", url: "/manage-companies/list" },
      { key: "labour_wages", url: "/config/labour-wages" },
      // Accounting
      { key: "project_payment_report", url: "/reports/project-payment-report" },
      { key: "employee_payment_report", url: "/payment/list" },
      { key: "weekly_payment_report", url: "/weeklyReport" },
      { key: "cash_in_hand", url: "/cash-in-hand" },
      // Labour Attendance
      { key: "site_engineer_weekly_sheet", url: "/weekly-labour-sheet" },
      // Settings
      { key: "labour_approvals", url: "/labour-approver-settings" },
      { key: "advance_relief_approver", url: "/advance-relief-approver-settings" },
      { key: "payment_approver", url: "/payment-approver-settings" },
      { key: "role_menu_permissions", url: "/config/role-menu-settings" },
    ];

    const allowed = menuMap.find(m => perms.some(p => p.submenu_key === m.key && p.can_view === 1));
    return allowed ? allowed.url : "/unauthorized";
  };

  const handleVerify2FA = async (code) => {
    setLoading2FA(true);
    try {
      const endpoint = twoFactorData.requireEnrollment
        ? `${baseURL}/login/enroll-2fa`
        : `${baseURL}/login/verify-2fa`;

      const reqData = JSON.stringify({
        tempToken: twoFactorData.tempToken,
        code,
        secret: twoFactorData.secret,
      });

      config.method = "POST";
      config.data = reqData;
      config.url = endpoint;

      const response = await axios(config);
      if (response.data.success && response.data.result && response.data.result.length > 0) {
        setShow2FAModal(false);
        const finalUser = response.data.result[0];
        localStorage.setItem("user", JSON.stringify(finalUser));

        localStorage.removeItem("isProjectLoggedIn");
        localStorage.removeItem("projectID");
        localStorage.removeItem("projectAutoID");
        localStorage.removeItem("projectName");
        localStorage.removeItem("projectCheckInTime");
        localStorage.removeItem("userAttandenceLogin");

        dispatch({ type: "LOGIN", payload: "jsonData" });
        
        if (finalUser.role_id === 36) {
          window.location.href = "/unauthorized";
        } else if (finalUser.role_id === 34) {
          window.location.href = "/dashboard";
        } else {
          const positionId = finalUser.position || finalUser.txtPosition;
          if (positionId) {
            axios.get(`${menuPermissionsAPI}/by-position/${positionId}`, {
              headers: {
                ...config.headers,
                Authorization: "Bearer " + finalUser.token
              }
            })
              .then((permRes) => {
                const perms = permRes.data.result || [];
                window.location.href = getFirstAllowedPage(perms);
              })
              .catch(() => {
                window.location.href = "/unauthorized";
              });
          } else {
            window.location.href = "/unauthorized";
          }
        }
      }
    } finally {
      setLoading2FA(false);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      if (user.role_id === 36) {
        navigate("/unauthorized");
      } else if (user.role_id === 34) {
        navigate("/dashboard");
      } else if (user.role_id === 35) {
        const positionId = user.position || user.txtPosition;
        if (positionId) {
          axios.get(`${menuPermissionsAPI}/by-position/${positionId}`, {
            headers: config.headers,
          })
            .then((response) => {
              const perms = response.data.result || [];
              const firstAllowed = getFirstAllowedPage(perms);
              navigate(firstAllowed);
            })
            .catch(() => {
              navigate("/unauthorized");
            });
        } else {
          navigate("/unauthorized");
        }
      }
    }

    return () => true;
  }, []);

  const handleForgotPassword = () => {
    setIsForgotPassword(!isForgotPassword);
  };

  const handleSendOTP = () => {
    setErrMessage("");
    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(forgotPasswordEmail)
    ) {
      setErrMessage("Please enter valid email");
      return false;
    }

    var reqData = JSON.stringify({
      txtUsername: forgotPasswordEmail,
      intType: 5,
    });
    config.method = "post";
    config.url = resetPasswordEmailAPI;
    config.data = reqData;
    // debugger;
    axios(config)
      .then(function (response) {
        if (response.data.message === "Invalid Email") {
          setErrMessage(response.data.message);
        } else {
          setIsSendOTP(!isSendOTP);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/adminlogin";
        }
        console.log(error);
        setErrMessage("Invalid Username or Password");
      });
  };

  const handleResetPassword = () => {
    setErrMessage("");
    if (txtResetPassword === "") {
      setErrMessage("Please enter password");
      return false;
    }
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/i.test(
        txtResetPassword
      )
    ) {
      setErrMessage(
        "Password Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      );
      return false;
    }

    if (txtResetPassword !== txtResetConfirmPassword) {
      setErrMessage("Passwords must match");
      return false;
    }

    var reqData = JSON.stringify({
      txtUsername: forgotPasswordEmail,
      txtPassword: txtResetPassword,
      intType: 8,
      txtOTP: intOTP,
    });
    config.method = "post";
    config.url = resetPasswordAPI;
    config.data = reqData;

    // debugger;
    axios(config)
      .then(function (response) {
        if (response.data.message === "Password updated") {
          childRef.current.triggerAlert(
            JSON.stringify({
              message: "Password Reset Successful",
              messageType: "success",
            })
          );
          setErrMessage("");
          setTimeout(function () {
            window.location.reload();
          }, 3000);
        } else {
          // setIsVerifiedOTP(!isVerifiedOTP);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/adminlogin";
        }
        console.log(error);
        setErrMessage("");
      });
  };

  const handleVerifyOTP = () => {
    var reqData = JSON.stringify({
      txtUsername: forgotPasswordEmail,
      intType: 10,
      intOTP: intOTP,
    });
    config.method = "post";
    config.url = verifyOTPAPI;
    config.data = reqData;

    // debugger;
    axios(config)
      .then(function (response) {
        if (response.data.message === "Invalid Otp") {
          setErrMessage(response.data.message);
        } else {
          setIsVerifiedOTP(!isVerifiedOTP);
          setErrMessage("");
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/adminlogin";
        }
        console.log(error);
        setErrMessage("Invalid Username or Password");
      });
  };

  return (
    <>
      <AlertMessage ref={childRef} />
      <Grid container className="full-height">
        <Grid
          className="padding-10 login-background"
          item
          xs={12}
          lg={3}
          md={3}
          alignItems="center"
        >
          <Grid textAlign="center">
            <img
              src={companyLogo}
              alt="LogRamcides Ticketing System (RTS)"
              className="logo-image"
            />
            <Typography variant="h4" mb={1} className="color-white">
              Ramcides Ticketing System (RTS)
            </Typography>
          </Grid>
          <Grid textAlign="Center">
            <img
              src={loginBackgroundImage}
              width={`130px`}
              alt="Login Background"
              className="login-background-img"
            />
          </Grid>
        </Grid>
        <Grid
          className="login-center"
          item
          xs={12}
          lg={9}
          md={9}
          alignItems="center"
        >
          <Grid className="inner-login-box  inner-login-admin">
            <Container>
              {isVerifiedOTP ? (
                <>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Reset Password
                    </Typography>
                    <div className="empty-space-20"></div>
                  </Grid>
                  <Grid>
                    <TextField
                      name="txtPassword"
                      type="password"
                      label="Password"
                      fullWidth
                      value={txtResetPassword}
                      onChange={(e) => setResetPassword(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Grid>
                    <TextField
                      name="txtPassword"
                      type="password"
                      label="Confirm Password"
                      fullWidth
                      value={txtResetConfirmPassword}
                      onChange={(e) => setResetConfirmPassword(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtPassword?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          onClick={handleResetPassword}
                          disabled={formState.isSubmitting}
                        >
                          Submit
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  </FormControl>
                </>
              ) : isSendOTP ? (
                <>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Enter OTP
                    </Typography>
                    <div className="empty-space-20"></div>
                  </Grid>
                  <Grid>
                    <TextField
                      name="txtEmail"
                      type="text"
                      label="Enter OTP"
                      fullWidth
                      value={intOTP}
                      onChange={(e) => setOTP(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>

                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <div className="empty-space-20"></div>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          onClick={handleVerifyOTP}
                          disabled={formState.isSubmitting}
                        >
                          Verify OTP
                        </LoadingButton>
                      </Grid>
                      <Grid item xs={12} lg={6} md={6} textAlign="right">
                        <a
                          onClick={() => setIsSendOTP(!isSendOTP)}
                          className="pointer"
                        >
                          Change email
                        </a>
                      </Grid>
                    </Grid>
                  </FormControl>
                </>
              ) : isForgotPassword ? (
                <>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Forgot Password
                    </Typography>
                    <div className="empty-space-20"></div>
                  </Grid>
                  <Grid>
                    <TextField
                      name="txtEmail"
                      type="text"
                      label="Email"
                      fullWidth
                      value={forgotPasswordEmail}
                      onChange={(e) => setForgotPasswordEmail(e.target.value)}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>

                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <div className="empty-space-20"></div>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          onClick={handleSendOTP}
                          disabled={formState.isSubmitting}
                        >
                          Send OTP
                        </LoadingButton>
                      </Grid>
                      <Grid item xs={12} lg={6} md={6} textAlign="right">
                        <a onClick={handleForgotPassword} className="pointer">
                          Cancel
                        </a>
                      </Grid>
                    </Grid>
                  </FormControl>
                </>
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid className="login-text-background">
                    <Typography variant="h4" textAlign="center">
                      Login
                    </Typography>
                  </Grid>
                  <Grid textAlign="center">
                    <div className="empty-space-40"></div>
                    <Typography variant="body" textAlign="center">
                      Login Using Your Registered Email ID and Password
                    </Typography>
                    <div className="empty-space-40"></div>
                    <TextField
                      name="txtEmail"
                      type="text"
                      label="Email"
                      fullWidth
                      {...register("txtEmail")}
                      className={`form-control ${
                        errors.txtEmail ? "is-invalid" : ""
                      }`}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtEmail?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Grid>
                    <TextField
                      name="txtPassword"
                      type="password"
                      label="Password"
                      fullWidth
                      {...register("txtPassword")}
                      className={`form-control ${
                        errors.txtPassword ? "is-invalid" : ""
                      }`}
                    />
                    <Typography className="invalid-feedback">
                      {errors.txtPassword?.message}
                    </Typography>
                  </Grid>
                  <div className="empty-space-20"></div>
                  <Typography className="invalid-feedback">
                    {errMessage}
                  </Typography>
                  <FormControl
                    sx={{ m: 0, width: "-webkit-fill-available" }}
                    variant="standard"
                  >
                    <div className="empty-space-20"></div>
                    <Grid container alignItems="center">
                      <Grid item xs={12} lg={6} md={6}>
                        <LoadingButton
                          size="large"
                          variant="contained"
                          color="primary"
                          type="submit"
                          disabled={formState.isSubmitting}
                        >
                          Login
                        </LoadingButton>
                      </Grid>
                      <Grid item xs={12} lg={6} md={6} textAlign="right">
                        <a onClick={handleForgotPassword} className="pointer">
                          Forgot Password?
                        </a>
                      </Grid>
                    </Grid>
                  </FormControl>
                </form>
              )}
            </Container>
          </Grid>
        </Grid>
      </Grid>
      <TwoFactorModal
        open={show2FAModal}
        onClose={() => setShow2FAModal(false)}
        requireEnrollment={twoFactorData.requireEnrollment}
        require2FA={twoFactorData.require2FA}
        qrCode={twoFactorData.qrCode}
        secret={twoFactorData.secret}
        onVerify={handleVerify2FA}
        loading={loading2FA}
      />
    </>
  );
}

export default Login;
